
import Vue from 'vue'
import Component, { mixins } from 'vue-class-component'
import Mixin from '../../mixin'
import { db } from '@/main'
import VueApexCharts from 'vue-apexcharts'

@Component({
  components: {
    VueApexCharts,
  },
})
export default class Dashboard extends mixins(Mixin) {
  premiumUsersList: Array<any> = []
  normalUsersList: Array<any> = []
  vagisesList: Array<any> = []
  monthSubscriptionsValues: Array<any> = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  premiumUsers = 0
  vagisesReported = 0
  normalUsers = 0
  loadingUsers = true
  loadingVagis = true
  currentYear = new Date().getFullYear()
  repeatedVagisesMap = new Map()

  finalBarChartData: Array<any> = []
  finalBarChartCategories: Array<any> = []

  lineChartOptions = {
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: true,
        easing: 'easeout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 800,
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: [
        'Ene',
        'Feb',
        'Mar',
        'Abr',
        'May',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dic',
      ],
    },
  }

  barChartOptions = {
    chart: {
      height: 350,
      type: 'bar',
      zoom: {
        enabled: false,
      },
    },
    xaxis: {
      categories: ['', '', '', '', '', '', '', '', '', ''],
    },
  }

  lineChartSeries = [
    {
      name: 'Suscripciones',
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
  ]

  barChartSeries = [
    {
      name: 'Reportes',
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
  ]

  async mounted() {
    try {
      await db
        .collection('users')
        .get()
        .then((querySnapshot) => {
          querySnapshot.docs.forEach((userDoc) => {
            const userData = userDoc.data()
            if (userData['premium']) {
              this.premiumUsersList.push(userData)
              debugger
              if (
                'premium_start' in userData &&
                userData['premium_start'].toDate().getFullYear() ==
                  this.currentYear
              ) {
                this.monthSubscriptionsValues[
                  this.getMonthByDate(userData['premium_start'])
                ] += 1
              }
            } else {
              this.normalUsersList.push(userData)
            }
          })
          this.premiumUsers = this.premiumUsersList.length
          this.normalUsers = this.normalUsersList.length
          this.loadingUsers = false

          this.lineChartSeries = [
            {
              name: 'Suscripciones',
              data: this.monthSubscriptionsValues,
            },
          ]
        })
      await db
        .collection('vagis')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((vagisDoc) => {
            const vagisData = vagisDoc.data()
            this.vagisesList.push(vagisData)
            if (Number(vagisData['year'] == this.currentYear)) {
              if (this.repeatedVagisesMap.size == 0) {
                this.repeatedVagisesMap.set(vagisData['name'].split('.')[1], 1)
              } else {
                if (
                  this.repeatedVagisesMap.has(vagisData['name'].split('.')[1])
                ) {
                  this.repeatedVagisesMap.set(
                    vagisData['name'].split('.')[1],
                    this.repeatedVagisesMap.get(
                      vagisData['name'].split('.')[1]
                    ) + 1
                  )
                } else {
                  this.repeatedVagisesMap.set(
                    vagisData['name'].split('.')[1],
                    1
                  )
                }
              }
            }
          })
          this.vagisesReported = this.vagisesList.length
          this.loadingVagis = false

          const repeatedVagisesSortedMap = new Map<string, any>(
            [...this.repeatedVagisesMap.entries()].sort((a, b) => b[1] - a[1])
          )

          const finalVagisesList: Array<any> = []

          repeatedVagisesSortedMap.forEach((key, value) => {
            finalVagisesList.push(new Map<string, any>().set(value, key))
          })

          if (finalVagisesList.length > 10) {
            for (let i = 0; i < 10; i++) {
              this.finalBarChartCategories.push(
                finalVagisesList[i].keys().next().value
              )
              this.finalBarChartData.push(
                finalVagisesList[i].values().next().value
              )
            }
          } else {
            finalVagisesList.forEach((element) => {
              this.finalBarChartCategories.push(element.keys().next().value)
              this.finalBarChartData.push(element.values().next().value)
            })
          }

          this.updateBarChart()
        })
    } catch (error) {
      console.log('Mounted error: ' + error)
    }
  }

  updateBarChart() {
    this.barChartOptions = {
      chart: {
        height: 350,
        type: 'bar',
        zoom: {
          enabled: false,
        },
      },
      xaxis: {
        categories: this.finalBarChartCategories,
      },
    }

    this.barChartSeries = [
      {
        name: 'Reportes',
        data: this.finalBarChartData,
      },
    ]
  }

  getMonthByDate(value) {
    return value.toDate().getMonth()
  }

  formatNumber(number: number) {
    try {
      console.log(number)
      return number > 999 && number < 1000000
        ? (number / 1000).toFixed(2) + ' ' + 'k'
        : number >= 1000000
        ? (number / 1000000).toFixed(2) + ' ' + 'M'
        : number
    } catch (error) {
      console.log('Error en formatNumber: ' + error)
    }
  }
}
